import { Suspense } from "react";
import Spinner from "../../components/feature-items/spinner/Spinner";
import "./contentWrapper.scss";

function ContentWrapper({
  children,
  colorScheme,
  borderColor = "brown",
  css,
  classes,
  noPadding = false,
}: {
  children?: any;
  colorScheme?: "grey" | "brown" | "white" | "blue" | "transparent";
  borderColor?: "brown" | "green" | "red" | "blue";
  css?: React.CSSProperties;
  classes?: string;
  noPadding?: boolean;
}) {
  return (
    <section
      className={`content-wrapper ${colorScheme} border_${borderColor} ${classes ? classes : ""} ${noPadding ? "noPadding" : ""}`}
      style={css}
    >
      <div style={css} className="content-wrapper__container">
        {/* Lazy pages suspend here, so header and bars stay visible */}
        <Suspense fallback={<Spinner inline />}>{children}</Suspense>
      </div>
    </section>
  );
}

export default ContentWrapper;
